import { FieldBases as Field } from 'module/types/filter-field/field/filterable-field';
import { ValueGetterParams } from 'ag-grid-community';
import { getBaseValueGetter } from './base-value-getter';

interface ValueGetter {
  (params: ValueGetterParams): any;
}

export const getValueGetter = (
  field: Pick<Field, 'type' | 'fieldName' | 'metaData'> & {
    fieldType?: string;
  },
): ValueGetter | undefined => {
  return getBaseValueGetter(field);
};
